<p i18n="@@ssoSigninView.overview" class="u-marginBottom-8 color-grey-300">
  This community allows you to sign in with your
  {{ this.ssoConnectionType }} account.
</p>
<div class="u-marginBottom-16">
  <ng-container [ngSwitch]="this.ssoConnectionType">
    <ng-container *ngSwitchCase="'Google'">
      <button
        i18n-aria-label="@@ssoSigninView.googleCta"
        (click)="ssoSignIn()"
        aria-label="Sign in with Google"
        class="c-button"
        [ngStyle]="{
          height: '46px',
          width: '191px',
          'background-image':
            'url(https://storage.googleapis.com/ttc-static-images/button/btn_google_signin_dark_normal_web%402x.png)',
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'background-size': 'contain'
        }"
      ></button>
    </ng-container>
    <ng-container *ngSwitchCase="'Microsoft'">
      <button
        i18n-aria-label="@@ssoSigninView.microsoftCta"
        (click)="ssoSignIn()"
        aria-label="Sign in with Microsoft"
        class="c-button"
        [ngStyle]="{
          height: '41px',
          width: '215px',
          'background-image':
            'url(https://storage.googleapis.com/ttc-static-images/button/microsoft_signin_dark.svg)',
          'background-position': 'center',
          'background-repeat': 'no-repeat',
          'background-size': 'contain'
        }"
      ></button>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <button
        i18n="@@ssoSigninView.defaultCta"
        mat-raised-button
        [attr.aria-label]="'Sign in with ' + ssoConnectionType"
        color="primary"
        (click)="ssoSignIn()"
      >
        Sign in with {{ this.ssoConnectionType }}
      </button>
    </ng-container>
  </ng-container>
</div>
<p *ngIf="ssoError?.message" class="u-padding-16 color-orange text-caption">
  <ng-container i18n="@@ssoSigninView.errorMessage"
    >{ ssoError.message, select, other {{{ ssoError.message }}} }</ng-container
  >
</p>
<p
  *ngIf="showPrivacyDisclaimer"
  i18n="@@ssoSigninView.privacyDisclaimer"
  class="text-caption color-grey-300"
>
  By clicking Sign in with {{ this.ssoConnectionType }} above, you are agreeing
  to our
  <a
    href="https://www.tenthousandcoffees.com/terms-conditions"
    class="color-blue"
    >Terms of Service</a
  >,
  <ng-container *ngIf="!tenant.legal?.link">and </ng-container>
  <a href="https://www.tenthousandcoffees.com/privacy-policy" class="color-blue"
    >Privacy Policy</a
  >
  <ng-container *ngIf="!tenant?.legal?.link">.</ng-container>
  <ng-container *ngIf="tenant?.legal?.link">
    and {{ tenant?.friendly_name | textToPossessive }}
    <a [href]="tenant?.legal?.link" target="_blank" class="color-blue">{{
      tenant.legal?.title
    }}</a
    >.
  </ng-container>
</p>
